export function convertUTCDateToLocal(oDateTime) {
  if (!oDateTime) return "";
  const date = new Date(oDateTime);

  const localTime = date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return localTime;
}
